export var version = {
  lib: '2.10124.2',
  product: '2.10124.2',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts